var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowdownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96548 6.24813C4.80696 6.25236 4.65294 6.30168 4.52149 6.39038C4.39005 6.47909 4.28664 6.60348 4.22341 6.74891C4.16018 6.89433 4.13976 7.0548 4.16453 7.21143C4.1893 7.36806 4.25825 7.51438 4.36327 7.63319L9.35838 13.4714C9.43662 13.5631 9.53382 13.6367 9.64327 13.6872C9.75271 13.7377 9.87181 13.7638 9.99234 13.7638C10.1129 13.7638 10.232 13.7377 10.3414 13.6872C10.4509 13.6367 10.548 13.5631 10.6263 13.4714L15.6263 7.63319C15.702 7.55073 15.7602 7.45387 15.7976 7.3484C15.8351 7.24292 15.8509 7.131 15.8441 7.01929C15.8373 6.90758 15.8081 6.79833 15.7582 6.69816C15.7083 6.59798 15.6388 6.50895 15.5537 6.43623C15.4686 6.36352 15.3698 6.30863 15.2631 6.27495C15.1563 6.24126 15.0439 6.22945 14.9325 6.24015C14.8211 6.25085 14.713 6.28385 14.6146 6.33723C14.5163 6.39061 14.4297 6.46323 14.36 6.55081L9.99152 11.6501L5.62466 6.55081C5.5447 6.45394 5.44387 6.37648 5.32973 6.32406C5.21558 6.27165 5.09106 6.24565 4.96548 6.24813Z",
    fill: "#C1C1C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdownIcon);
export default __webpack_public_path__ + "static/media/arrowdown-icon.7025fa298dc450b9a8fe7d194b3da3e0.svg";
export { ForwardRef as ReactComponent };